import HttpService from '@/shared/services/HttpService';
import {getIdFromIri} from "@/shared/utils";

class LobbyService {
    private http = new HttpService();
    public async fetchCompetitions() {
        try {
            const response = await this.http.get('football/data/competitions');
            if (response) {
                return response['hydra:member'].map((competition: any) => ({
                    id: getIdFromIri(competition['@id']),
                    name: competition.name,
                }));
            }
        } catch (e) {
            return e;
        }
    }

    public async fetchContests(filters?: any, pageUrl?: any) {
        const query = Object.keys(filters).map((key) => `${key}=${filters[key]}`).join('&');
        const url = pageUrl ? pageUrl.substring(1) : `football/contests?pagination=true&${query}`;
        try {
            const response = await this.http.get(url);
            return {
                items: response['hydra:member'].map((item: any) => ({
                    totalWinnings: item.totalWinnings,
                    winners: item.numWinners,
                    spots: item.entries.length,
                    totalSpots: item.maximumPlayers,
                    entryFee: item.moneyAmount / 100,
                    id: item.id,
                    ['@id']: item['@id'],
                    title: item.title,
                    competitionName: item.competitionName || 'Liga española',
                })),
                description: 'Contests catered to you',
                title: 'Recommended for you',
                error: false,
                loading: false,
                tag: 'begginer',
                total: response['hydra:totalItems'],
                nextpage: response['hydra:view']['hydra:next']
            };

        } catch (e) {
            return e;
        }
    }

    public async fetchMatches(filters?: any) {
        const query = filters ? Object.keys(filters).map((key) => `${key}=${filters[key]}`).join('&') : '';
        try {
            const response = await this.http.get(`football/data/games?${query}`);
            if (response) {
                return response['hydra:member'].map((match: any) => ({
                    homeTeam: match.homeTeam,
                    awayTeam: match.awayTeam,
                    startedAt: match.startedAt,
                    competitionId: getIdFromIri(match.competition)
                })).slice(0, 10 );
            }
        } catch (e) {
            return e;
        }
    }
}

export default new LobbyService();
